module.exports = __webpack_public_path__ + "img/white_logo.3c7f33a1.svg";